import { parse } from 'query-string';
var OPTIMIZELY_OVERRIDE = 'optimizely_feature_override:';
export var shimOptimizelyClient = function shimOptimizelyClient(optimizely) {
  var original = optimizely.isFeatureEnabled.bind(optimizely);

  optimizely.isFeatureEnabled = function (feature, overrideUserId, overrideAttributes) {
    var override = localStorage.getItem("".concat(OPTIMIZELY_OVERRIDE).concat(feature));
    if (override === 'true') return true;
    if (override === 'false') return false;
    return original(feature, overrideUserId, overrideAttributes);
  };
};
export var setFeatureOverride = function setFeatureOverride(feature) {
  localStorage.setItem("".concat(OPTIMIZELY_OVERRIDE).concat(feature[0]), feature[1]);
};
export var removeFeatureOverride = function removeFeatureOverride(feature) {
  localStorage.removeItem("".concat(OPTIMIZELY_OVERRIDE).concat(feature));
};
export var initializeOptimizelyOverride = function initializeOptimizelyOverride(optimizely) {
  var queryParams = "".concat(window.location.search);

  if (queryParams.includes('feature_overrides')) {
    var queryString = parse(queryParams);

    if (typeof queryString.feature_overrides === 'string') {
      var features = queryString.feature_overrides.split(',').map(function (featureToggle) {
        return featureToggle.split('.');
      });
      features.forEach(function (feature) {
        return setFeatureOverride(feature);
      });
    }
  }

  shimOptimizelyClient(optimizely);
};